import React from 'react';
import { NextPage } from 'next';

import { Privacy } from '@edx/pages/privacy';

import { EDX_EMAIL, EDX_URL } from '@edb/config/app';

const PrivacyPage: NextPage = () => <Privacy url={EDX_URL} email={EDX_EMAIL} />;

export default PrivacyPage;
